export type EnrichableField = "description" | "shortDescription" | "seoTitle" | "metaDescription" | "seoKeywords";

export function fieldIsUserEdited(value: string | null | undefined): boolean {
  return String(value ?? "").trim().length > 0;
}

/** AI drafts never silently overwrite non-empty operator fields. */
export function mergeEnrichmentFields(
  current: Record<EnrichableField, string>,
  draft: Partial<Record<EnrichableField, string>>,
  overwriteConfirmed: boolean,
): Record<EnrichableField, string> {
  const next = { ...current };
  for (const key of Object.keys(draft) as EnrichableField[]) {
    const incoming = draft[key];
    if (incoming == null) continue;
    if (!fieldIsUserEdited(current[key]) || overwriteConfirmed) {
      next[key] = incoming;
    }
  }
  return next;
}

export function enrichmentNeedsOverwriteConfirm(
  current: Record<EnrichableField, string>,
  draft: Partial<Record<EnrichableField, string>>,
): boolean {
  return (Object.keys(draft) as EnrichableField[]).some(
    (key) => draft[key] != null && fieldIsUserEdited(current[key]),
  );
}
